import axiosInstance from "../lib/axiosInstance";

export const fetchWebsiteContent = (userId) => {
  return axiosInstance.get(`/admin/users/${userId}/website`);
};

export const updateWebsite = (websiteId, params) => {
  return axiosInstance.put(`/admin/websites/${websiteId}`, params);
};
